/**
 * Filter Indicators Component
 * 
 * Shows active filters as removable chips
 * Format: Icon | Label | Is | Value | ×
 */
import { __ } from '@wordpress/i18n';

const FilterIndicators = ({ filters, statuses = {}, categories, onRemoveFilter }) => {
    // Build dynamic status labels from prop.
    const statusLabels = {};
    Object.keys(statuses).forEach((slug) => {
        statusLabels[slug] = statuses[slug].label || slug;
    });

    const categoryLabels = {
        'feature_requests': __( 'Feature Request', 'changeloger' ),
        'bug_reports': __( 'Bug Report', 'changeloger' ),
        'integrations': __( 'Integration', 'changeloger' ),
        'languages': __( 'Language', 'changeloger' ),
        ...(categories || {})
    };

    const dateLabels = {
        'today': __( 'Today', 'changeloger' ),
        'this_week': __( 'This Week', 'changeloger' ),
        'this_month': __( 'This Month', 'changeloger' ),
        'this_year': __( 'This Year', 'changeloger' )
    };

    // Check if any filters are active
    const hasActiveFilters = filters.status || filters.board || filters.date;
    
    if (!hasActiveFilters) return null;

    return (
        <div className="cha-filter-indicators">
            {/* Status Filter */}
            {filters.status && (
                <div className="cha-filter-chip">
                    <span className="cha-chip-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>
                    <span className="cha-chip-label">{__( 'Status', 'changeloger' )}</span>
                    <span className="cha-chip-separator">{__( 'Is', 'changeloger' )}</span>
                    <span className="cha-chip-value">{statusLabels[filters.status] || filters.status}</span>
                    <button 
                        className="cha-chip-remove"
                        onClick={() => onRemoveFilter('status')}
                    >
                        ×
                    </button>
                </div>
            )}

            {/* Board/Category Filter */}
            {filters.board && (
                <div className="cha-filter-chip">
                    <span className="cha-chip-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A2 2 0 013 12V7a4 4 0 014-4z" />
                        </svg>
                    </span>
                    <span className="cha-chip-label">{__( 'Board', 'changeloger' )}</span>
                    <span className="cha-chip-separator">{__( 'Is', 'changeloger' )}</span>
                    <span className="cha-chip-value">
                        <span className="cha-chip-emoji">💡</span>
                        {categoryLabels[filters.board] || filters.board}
                    </span>
                    <button 
                        className="cha-chip-remove"
                        onClick={() => onRemoveFilter('board')}
                    >
                        ×
                    </button>
                </div>
            )}

            {/* Date Filter */}
            {filters.date && (
                <div className="cha-filter-chip">
                    <span className="cha-chip-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                    </span>
                    <span className="cha-chip-label">{__( 'Date', 'changeloger' )}</span>
                    <span className="cha-chip-separator">{__( 'Is', 'changeloger' )}</span>
                    <span className="cha-chip-value">{dateLabels[filters.date] || filters.date}</span>
                    <button 
                        className="cha-chip-remove"
                        onClick={() => onRemoveFilter('date')}
                    >
                        ×
                    </button>
                </div>
            )}
        </div>
    );
};

export default FilterIndicators;
